import { buildProps } from '@lit-element/utils'
import type { ExtractPropTypes, PropType } from 'vue'
import type renderer from './renderer'

export const rendererProps = buildProps({
  renderer: {
    type: Function,
    default: null,
  },
  data: {
    type: Object as PropType<Record<string, any>>,
    default: undefined,
  },
} as const)
export type RendererProps = ExtractPropTypes<typeof rendererProps>
export type RendererInstance = InstanceType<typeof renderer>
